'use strict';

require('./ReportOrderByBatchNumber.scss');

const React = require('react'),
  {t} = require('services/i18nextWrapper'),
  InventoryStore = require('stores/InventoryStore'),
  {cloneDeep} = require('lodash/lang'),
  get = require('lodash/object').get,
  {CircularProgress} = require('material-ui'),
  FormGroupButton = require('components/Commons/BasicForm/FormGroupButton/FormGroupButton'),
  TextField = require('components/Commons/TextField/TextField');

const ReportByItemTransaction = React.createClass({displayName: "ReportByItemTransaction",

  getInitialState() {
    return {
      filter: {
        moduleName: 'REPORT_ORDER_BY_BATCH_NUMBER',
        messageErrorItem: '',
        batchNumber: '',
        reportKey: ''
      }
    };
  },

  _onSubmit() {
    let filter = cloneDeep(this.state.filter);
    filter.batchNumber = get(this.state, 'batchNumber');

    if (!filter.batchNumber) {
      this.setState({
        messageErrorItem: t('report_batch_number_inline_error_batch_number_is_required')
      });
      return;
    }

    filter.reportKey = 'REPORT_ORDER_BY_BATCH_NUMBER';
    this.setState({
      isGeneratingReport: true
    }, () => {
      InventoryStore.downloadReportXLS(
        filter,
        `/orders/by-batch-number/${filter.batchNumber}`,
        () => {
          this.setState({
            isGeneratingReport: false,
            messageErrorItem: ''
          });
        },
        () => {
          this.setState({
            isGeneratingReport: false,
            messageErrorItem: t('report_error_not_found_by_batch_number')
          });
        }
      );
    });

  },

  onBlurBatchNumber(evt) {
    this.setState({
      batchNumber: evt.target.value
    });
  },

  render() {
    const {batchNumber, isGeneratingReport} = this.state;
    const messageError = this.state.messageErrorItem || this.state.error || '';

    return (
      React.createElement("div", {className: "report-by-beer-style"}, 
        React.createElement("div", {className: "report-by-beer-style__header"}, t('report_batch_number_title')), 
        React.createElement("div", {className: "report-by-beer-style__body"}, 
          React.createElement("div", {className: "report-by-beer-style__body-row"}, 
            React.createElement("label", {style: {marginBottom: 0}, className: "report-by-beer-style__body-row-title-show-by"}, 
              t('report_batch_number_batch_number')), 
            React.createElement(TextField, {
              className: "full-width id-username", 
              hintText: t('report_batch_number_enter_batch_number'), 
              defaultValue: batchNumber, 
              floatingLabelText: t('report_batch_number_batch_number'), 
              onEnterKeyDown: this.handleSubmit, 
              errorText: messageError, 
              onBlur: this.onBlurBatchNumber
            }
            )
          ), 
          React.createElement("div", {className: "report-by-beer-style__submit"}, 
            React.createElement(FormGroupButton, {
              className: "primary-icon", 
              type: "icon", 
              label: t('report_item_download_report'), 
              onClick: isGeneratingReport ? () => {} : this._onSubmit}
            ), 
            isGeneratingReport && React.createElement(CircularProgress, {size: .4})
          )
        )
      )
    );
  }
});

module.exports = ReportByItemTransaction;



/** WEBPACK FOOTER **
 ** ./src/views/ReportAdmin/ReportOrderByBatchNumber/ReportOrderByBatchNumber.jsx
 **/